/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sanction_Sub_Failure_To_Play_To_WinInputs */



/**
* | output |
* | --- |
* | "Failure to Play to Win" |
*
* @param {Sanction_Sub_Failure_To_Play_To_WinInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_sub_failure_to_play_to_win = /** @type {((inputs?: Sanction_Sub_Failure_To_Play_To_WinInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_Sub_Failure_To_Play_To_WinInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Échec de Jouer pour Gagner")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fallo en Jugar para Ganar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Falha em Jogar para Vencer")
	if (locale === "it") return /** @type {LocalizedString} */ ("Mancata Volontà di Vincere")
	return /** @type {LocalizedString} */ ("Failure to Play to Win")
});